<!-- 预约导师 -->
<template>
  <div class="application-mentor">
    <!-- zoom 提示 -->
    <div v-if="!isTencentVideoShow">
      <zoom-piao-chuang></zoom-piao-chuang>
    </div>
    <input type="text"
           id="domFocus"
           style="opacity:0;position: absolute;">
    <zlr-progress :percent="percent"
                  :stick=true></zlr-progress>
    <div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="application-mentor-title">
            0. 选择视频工具
          </div>
          <!-- v-if="isTencentVideoShow" -->
          <div class="application-mentor-tools">
            <span @click="vidoeHandle('TENCENT')"
                  :class="{'active-bg': formData.videoType === 'TENCENT'}"
                  >MSP内置视频聊天（试用）</span>
            <!-- <span v-else
                  @click="vidoeHandle('ZOOM')"
                  :class="{'active-bg': formData.videoType === 'ZOOM'}">Zoom视频会议（原有）</span> -->
          </div>
          <!-- 环境检测https://www.qcloudtrtc.com/webrtc-samples/abilitytest/index.html -->
          <div class="tencent-note"
               v-if="isTencentVideoShow">
            Note: 试用内置视频聊天, 请先<a target="_blank"
               href="https://web.sdk.qcloud.com/trtc/webrtc/demo/detect/index.html">跳转检测</a>使用环境；如有相关问题，欢迎通过“问题反馈”反馈</div>
        </div>
      </div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="dis-40">
            <div class="application-mentor-title">
              1. 选择模块
            </div>
            <div>
              <Tabs v-model="tabName" @on-click="handleTab">
                  <TabPane label="非申请季" name="unApplyName">
                    <div>
                      <div class="application-mentor-module">
                        <span v-for="(item, index) in smcmModuleMapChange"
                        :key="index"
                        @click="moduleHandle(item.value)"
                        :class="{'active-bg': formData.module === item.value}">{{ item.title }}</span>
                      </div>
                      <div class="select-box" v-if="isShowSelect" style="padding-bottom:30px;">
                        <div class="slect-title">请选择课程</div>
                        <Select  v-model="formData.courseId"  :rules="[{required:true,message:'请选择课程'}]" placeholder="请选择课程">
                            <Option :value="item.id" v-for="item in unApplyOptionList" :key="item.id">{{item.name}}</Option>
                        </Select>
                        <div v-for="item in unApplyOptionList" :key="item.name">
                        <div class="select-tip-main">
                          <div v-if="formData.courseId === item.id">
                            <div class="course-mian">
                             <span class="course-title-left">课程名称:</span><span v-html="item.name"></span>
                            </div>
                            <div class="course-mian">
                              <span class="course-title-left">课程时长:</span><span v-html="item.suggestTimeDesc "></span>
                            </div>
                            <div class="course-mian">
                              <span class="course-title-left">课程详细指引:</span><span v-html="item.guide"></span>
                            </div>
                            <div class="course-mian">
                              <span class="course-title-left">课程效果:</span><span v-html="item.purpose"></span>
                            </div>
                          </div>
                        </div>
                        </div>
                       </div>
                    </div>
                  </TabPane>
                  <TabPane label="申请季" name="applyName">
                    <div class="application-mentor-module">
                      <span v-for="(item, index) in smcmModuleMap"
                      :key="index"
                      @click="moduleHandle(item.value)"
                      :class="{'active-bg': formData.module === item.value}">{{ item.title }}</span>
                    </div></TabPane>
              </Tabs>
            </div>
            <div :class="{'application-mentor-cover': !formData.videoType }"></div>
          </div>
          <div class="dis-40">
            <div class="application-mentor-title">
              2. 选择导师
            </div>
            <div class="application-mentor-mentor">
              <div v-for="(item, index) in mentorList"
                   :key="index"
                   @click="selMentorHandle(item)"
                   :class="{'active-bg':item.id === formData.jointId}">
                <div class="left">
                  <img :src="item.mentorInfo.avaurl || MentorAvatar"
                       alt="头像">
                </div>
                <div class="right">
                  <p>{{ item.mentorName }}</p>
                  <div>{{item.mentorType}}导师</div>
                </div>
              </div>
            </div>
            <div class="application-mentor-mentor-prompt"
                 v-if="typeof remainTime.remainTime === 'number' && remainTime.remainTime <= 0 ">
              <div>{{formData.module | filtersMentorTitle}}{{` - ${selMentorDetail.mentorName}，套餐内上限时间为 ${remainTime.maxTime}mins，已使用 ${remainTime.usedTime}mins，剩余 ${remainTime.remainTime}mins`}}</div>
              <a  @click="handleReplaceDiy">请置换时间或联系CD购买服务</a>
               <!-- 模块1-3 -->
              <replace-book ref="replaceBook"
                            @on-success="handleReplaceSuc"></replace-book>
              <!-- 模块7.8 -->
              <replace-diy ref="repalceDiy"
                          @on-success="handleReplaceSuc"></replace-diy>
            </div>
            <div :class="{'application-mentor-cover':(!formData.module&&(tabName === 'applyName')&&(isShowSelect === false)) ||(!formData.module||(tabName === 'unApplyName')&&(isShowSelect===true)&&(!formData.courseId)) }"></div>
          </div>
          <div class="dis-40">
            <div class="application-mentor-title">
              3. 预计讨论时间
            </div>
            <div class="application-mentor-expect">
              <span v-for="(time,index) in expectTimeList"
                    :key="index"
                    @click="predictTimeHandle(time)"
                    :class="{'active-bg': formData.predictTime === time}">{{time}}mins</span>
            </div>
            <div :class="{'application-mentor-cover':!formData.jointId}"></div>
          </div>
          <div class="dis-0">
            <div class="application-mentor-title">
              4. 讨论主题
            </div>
            <div class="application-mentor-theme">
              <!-- 有值加class  active -->
              <div :class="['application-mentor-theme-input',formData.title?'active':'']">
                <Input placeholder="e.g. Kick Off / PS Brainstorm / Essay Brainstorm"
                       v-model="formData.title"
                       @on-blur="titleBlurHandle"></Input>
              </div>
              <div class="application-mentor-theme-prompt"
                   @click="themeHandle">
                <img :src="Info"
                     alt="">
              </div>
            </div>
            <div :class="{'application-mentor-cover':!formData.predictTime}"></div>
          </div>
        </div>
      </div>
      <div class="application-mentor-item application-mentor-tips"
           v-if="showTips">
        <!-- 两种颜色 orange blue -->
        <div :class="['application-mentor-container', remainTime.remainTime<=30?'orange': 'blue']">
          <div class="application-mentor-tips-top">
            <span>Tips</span>
            <div></div>
          </div>
          <div class="application-mentor-tips-con">
            <ul>
              <li class="dis-36 book-sm">{{`${['MODULE_1', 'MODULE_2', 'MODULE_3', 'MODULE_7'].includes(formData.module)?'文书辅导，SM导师':'个性化辅导，CM导师'} - ${selMentorDetail.mentorName}，套餐内上限时间为 ${remainTime.maxTime}mins，已使用 ${remainTime.usedTime}mins，剩余 ${remainTime.remainTime}mins`}}</li>
              <li>{{ `${selMentorDetail.mentorType}导师 - ${selMentorDetail.mentorName}，所在时区为：`}}{{selMentorDetail.mentorInfo.mentorZone| filterZone}}</li>
              <li class="dis-36"
                  v-if="selMentorDetail.mentorType !== 'EM'">导师预期每周空闲时间：{{selMentorDetail.mentorInfo&&selMentorDetail.mentorInfo.mentorFreeTimes | filterWeek}}</li>
              <li>建议预约9天内、9小时后的时间段内的时间，这样能大幅提高预约的成功率哟！</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="dis-40">
            <div class="application-mentor-title">
              5. 您所在时区
            </div>
            <div class="application-mentor-zone">
              <!-- 有值加class  active-select -->
              <div :class="{'active-select': formData.menteeZone}">
                <Select placeholder="Select"
                        v-model="formData.menteeZone"
                        @on-change="changeMenteeZone">
                  <Option :value="item.value"
                          v-for="(item,index) in zoneMap"
                          :key="index">{{item.title}}</Option>
                </Select>
              </div>
            </div>
            <div :class="{'application-mentor-cover':!formData.title}"></div>
          </div>
          <div class="dis-40">
            <div class="application-mentor-title">
              6. 您期望辅导时间 - 优先
            </div>
            <div class="application-mentor-coach">
              <div class="application-mentor-coach-list"
                   :class="{'active':formData.timeContent[0][0],'active-error':compareTime[0]}">
                <DatePicker type="date"
                            placeholder="Select date"
                            style="width:100%;"
                            @on-change="firstDateHandle"
                            v-model="formData.timeContent[0][0]"
                            :options="optionsTime"></DatePicker>
              </div>
              <div class="application-mentor-coach-list "
                   :class="{'active':formData.timeContent[0][1]&& formData.timeContent[0][1][0], 'active-error':compareTime[0]}">
                <TimePicker type="timerange"
                            placeholder="Select time"
                            style="width:100%;"
                            format="HH:mm"
                            :steps="[1, 10]"
                            @on-change="firstTimeHandle"
                            v-model="formData.timeContent[0][1]"></TimePicker>
              </div>
            </div>
            <div class="application-mentor-coach-prompt"
                 v-if="compareTime[0]">
              建议重新选择时间，时间段在导师所在时区的：00:00 - 06:00
            </div>
            <div :class="{'application-mentor-cover':!formData.menteeZone}"></div>
          </div>
          <div class="dis-40">
            <div class="application-mentor-title">
              7. 您期望辅导时间 - 次要
            </div>
            <div class="application-mentor-coach">
              <div class="application-mentor-coach-list"
                   :class="{'active':formData.timeContent[1][0], 'active-error':compareTime[1]}">
                <DatePicker type="date"
                            placeholder="Select date"
                            style="width:100%;"
                            @on-change="secondDateHandle"
                            v-model="formData.timeContent[1][0]"
                            :options="optionsTime"></DatePicker>
              </div>
              <div class="application-mentor-coach-list"
                   :class="{'active':formData.timeContent[1][1] && formData.timeContent[1][1][0], 'active-error':compareTime[1]}">
                <TimePicker type="timerange"
                            placeholder="Select time"
                            style="width:100%;"
                            format="HH:mm"
                            :steps="[1, 10]"
                            @on-change="secondTimeHandle"
                            v-model="formData.timeContent[1][1]"></TimePicker>
              </div>
            </div>
            <div class="application-mentor-coach-prompt"
                 v-if="compareTime[1]">
              建议重新选择时间，时间段在导师所在时区的：00:00 - 06:00
            </div>
            <div :class="{'application-mentor-cover':!formData.timeContent[0][0]||!(formData.timeContent[0][1]&&formData.timeContent[0][1][0])}"></div>
          </div>
          <div v-if="isAddTimeContent">
            <div class="dis-40">
              <div class="application-mentor-title">
                8. 您期望辅导时间 - 次要
              </div>
              <div class="application-mentor-coach">
                <div class="application-mentor-coach-list"
                    :class="{'active':formData.timeContent[2][0],'active-error':compareTime[2]}">
                  <DatePicker type="date"
                              placeholder="Select date"
                              style="width:100%;"
                              @on-change="threeDateHandle"
                              v-model="formData.timeContent[2][0]"
                              :options="optionsTime"></DatePicker>
                </div>
                <div class="application-mentor-coach-list"
                    :class="{'active':formData.timeContent[2][1] && formData.timeContent[2][1][0],'active-error':compareTime[2]}">
                  <TimePicker type="timerange"
                              placeholder="Select time"
                              style="width:100%;"
                              format="HH:mm"
                              :steps="[1, 10]"
                              @on-change="threeTimeHandle"
                              v-model="formData.timeContent[2][1]"></TimePicker>
                </div>
              </div>
              <div class="application-mentor-coach-prompt"
                  v-if="compareTime[2]">
                建议重新选择时间，时间段在导师所在时区的：00:00 - 06:00
              </div>
              <!-- <div :class="{'application-mentor-cover':!formData.timeContent[1][0]||!(formData.timeContent[1][1]&&formData.timeContent[1][1][0])}"></div> -->
            </div>
          </div>
          <div class="dis-0">
            <div><Button @click="chanbgeAddTimeContent">{{!isAddTimeContent?'添加次要辅导时间':'删除次要辅导时间'}}</Button></div>
            <div :class="{'application-mentor-cover':!formData.timeContent[1][0]||!(formData.timeContent[1][1]&&formData.timeContent[1][1][0])}"></div>
          </div>
        </div>
      </div>
      <div v-if="!isAddTimeContent">
        <div class="application-mentor-item application-mentor-tips"
            v-if="formData.timeContent[1][0]&&formData.timeContent[1][1] &&formData.timeContent[1][1][0]">
          <!-- 两种颜色 orange blue -->
          <div class="application-mentor-container"
              :class="[tipsColor]">
            <div class="application-mentor-tips-top">
              <span>Tips</span>
              <div></div>
            </div>
            <div class="application-mentor-tips-con">
              <ul>
                <li>您所期望的时间：</li>
                <!-- class="book-sm" -->
                <li v-for="(item, index) in formData.timeContent"
                    :key="index">
                    <div v-if="item && item.length>0">
                      {{item | filerExpectTime}}{{index === 0? '（优先）': ''}} {{transferMenteetime[index]| compareMenteeTime}}
                    </div>
                </li>
              </ul>
              <ul>
                <li>对应导师所在时区时间：</li>
                <li v-for="(item, index) in transferMentortime"
                    :key="index"
                    :class="{'book-sm':index === 0}"><div v-if="item.minTimeStr || item.maxTimeStr">{{item.minTimeStr}} - {{item.maxTimeStr}} {{index===0? '（优先）': ''}}</div></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAddTimeContent">
        <div class="application-mentor-item application-mentor-tips"
            v-if="formData.timeContent[2][0]&&formData.timeContent[2][1] &&formData.timeContent[2][1][0]">
          <!-- 两种颜色 orange blue -->
          <div class="application-mentor-container"
              :class="[tipsColor]">
            <div class="application-mentor-tips-top">
              <span>Tips</span>
              <div></div>
            </div>
            <div class="application-mentor-tips-con">
              <ul>
                <li>您所期望的时间：</li>
                <!-- class="book-sm" -->
                <li v-for="(item, index) in formData.timeContent"
                    :key="index">
                  {{item | filerExpectTime}}{{index === 0? '（优先）': ''}} {{transferMenteetime[index]| compareMenteeTime}}
                </li>
              </ul>
              <ul>
                <li>对应导师所在时区时间：</li>
                <li v-for="(item, index) in transferMentortime"
                    :key="index"
                    :class="{'book-sm':index === 0}">{{item.minTimeStr}} - {{item.maxTimeStr}} {{index===0? '（优先）': ''}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="application-mentor-item">
        <div class="application-mentor-container">
          <div class="dis-0">
            <div class="application-mentor-title">
              其它您想告知导师的信息（请用英文填写）
            </div>
            <div>
              <editor ref="analysisEditor"
                      :cache=false
                      v-model.trim="formData.description" />
            </div>
            <div class="application-mentor-btn">
              <Button class="application-mentor-btn-back"
                      @click="backHandle">返回</Button>
              <div v-if="isallowedit" style="display: inline-block;">
                <Button class="application-mentor-btn-sub"
                        type="primary"
                        @click="subHandle"
                        :loading="isSub">发起预约</Button>
              </div>
            </div>
            <div v-if="!isAddTimeContent">
              <div :class="{'application-mentor-cover':!formData.timeContent[1][0]||!formData.timeContent[1][1] ||!formData.timeContent[1][1][0]}"></div>
            </div>
            <div v-if="isAddTimeContent">
              <div :class="{'application-mentor-cover':!formData.timeContent[2][0]||!formData.timeContent[2][1] ||!formData.timeContent[2][1][0]}"></div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 讨论主体提示 -->
    <theme ref="theme"></theme>
  </div>
</template>
<script>
import isAllowEdit from '@/view/mixins/is-edit'
// api
import { getJointSMCM, getJointSM, getJointCM } from '@/api/joint'
import { getAppCreate, getAppRemainTime, getAppTimeConvert } from '@/api/appointment'
import { getTencentVideoShow, getInfoApplicationSelect, infoQueryDetail } from '@/api/info'

// images
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
import Info from '@/assets/images/home/Info.svg'
// components
import ZlrProgress from '_c/progress/progress'
import Editor from '_c/editor/editor'
import Theme from './components/application-mentor-theme'
import ZoomPiaoChuang from './components/application-mentor-zoom'
// components
import ReplaceDiy from '../components/replace-diy'
import ReplaceBook from '../components/replace-book'
// constant
import { smcmModuleMap, zoneMap, week } from '@/constant'
import dayjs from 'dayjs'
export default {
  name: 'mentor-application-mentor',
  mixins: [isAllowEdit],
  components: {
    ZlrProgress,
    Editor,
    Theme,
    ZoomPiaoChuang,
    ReplaceDiy,
    ReplaceBook
  },
  data () {
    return {
      MentorAvatar,
      smcmModuleMap: smcmModuleMap.filter(item => item.value !== 'INTERVIEW'),
      smcmModuleMapChange: smcmModuleMap.filter(item => item.value !== 'INTERVIEW').slice(-2),
      zoneMap,
      optionsTime: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      // 预计讨论时间
      expectTimeList: [15, 30, 45, 60, 75, 90],
      formData: {
        timeContent: [[], [], []],
        courseId: ''
      },
      Info,
      percent: 0,
      mentorList: [],
      remainTime: {},
      selMentorDetail: null,
      showTips: false,
      // 进行时间比较
      compareTime: [],
      // 转换导师
      transferMentortime: [{}, {}, {}],
      transferMenteetime: [{}, {}, {}],
      tipsColor: '',
      // 腾讯视频是否展示
      isTencentVideoShow: false,
      isSub: false,
      // 选择模块
      tabName: 'unApplyName',
      isShowSelect: false,
      unApplyOptionList: [],
      detail: {},
      packageInfo: {},
      packageId: '',
      isAddTimeContent: false

    }
  },
  computed: {},
  mounted () {
    document.getElementById('domFocus').focus()
    // 获取SMCM导师
    this.getJointSMCM()
    this.getTencentVideoShow()
    this.getDetail()
  },
  methods: {
    // 获取用户信息
    getDetail () {
      var date = new Date()
      var afterYear = date.getFullYear() + 1
      infoQueryDetail({}).then(res => {
        if (res.code === 0) {
          this.packageId = res.data.model.packageId
          if (this.packageId === 120 || this.packageId === 121) {
            this.handlesmcmModuleMap()
          } else {
            this.smcmModuleMap = smcmModuleMap.filter(item => item.value !== 'INTERVIEW')
          }
          if (res.data.model.packageInfo) {
            this.packageInfo = res.data.model.packageInfo
          }
          this.detail = res.data.model
          if (this.detail.inYear <= afterYear) {
            this.tabName = 'applyName'
          } else {
            this.tabName = 'unApplyName'
          }
        }
      })
    },
    handlesmcmModuleMap () {
      let arr = smcmModuleMap.filter(item => item.value !== 'INTERVIEW')
      arr.splice(1, 2)
      this.smcmModuleMap = arr
      this.smcmModuleMap[0].title = 'PS Brainstorming'
    },
    // 获取腾讯视频是否展示
    getTencentVideoShow () {
      getTencentVideoShow().then(res => {
        this.isTencentVideoShow = res.data.model
      })
    },
    // 提交预约
    subHandle () {
      let data = JSON.parse(JSON.stringify(this.formData))
      data.content = []
      data.timeContent.forEach(item => {
        if (item.length > 0) {
          let date = dayjs(item[0]).format('YYYY-MM-DD')
          data.content.push({
            maxTimeStr: `${date} ${item[1][1]}`,
            minTimeStr: `${date} ${item[1][0]}`
          })
        }
      })
      delete data.timeContent
      this.isSub = true
      getAppCreate(data).then(res => {
        this.$zlr_message('发起预约成功，待导师确认', 'success')
        this.backHandle()
      }).catch(error => {
        this.isSub = false
        this.$zlr_message(error.message, 'error')
      })
    },
    // 选择视频
    vidoeHandle (value) {
      this.$set(this.formData, 'videoType', value)
      this.moduleHandle('')
    },
    // 选择模块
    moduleHandle (value) {
      this.unApplyOptionList = []
      this.isShowSelect = false
      this.formData.courseId = ''
      if (this.tabName === 'unApplyName' && (value === 'MODULE_7' || value === 'MODULE_8')) {
        this.getSelectInfo(value)
      }
      let type = ''
      if (value === 'MODULE_1' || value === 'MODULE_2' || value === 'MODULE_3') {
        type = 'MATERIAL'
        this.getJointSM()
      } else if (value === 'MODULE_7') {
        type = 'COACH'
        this.getJointSM()
      } else if (value === 'MODULE_8') {
        type = 'COACH'
        this.getJointCM()
      } else {
        this.getJointSMCM()
      }
      this.$set(this.formData, 'module', value)
      this.$set(this.formData, 'type', type)
      this.selMentorHandle({})
    },
    // 获取下拉框信息
    getSelectInfo (value) {
      if (this.packageInfo && this.packageInfo.oriented && this.packageInfo.detail && this.packageInfo.detail.packageType && this.packageInfo.hasCourse) {
        let data = {}
        data.oriented = this.packageInfo.oriented
        data.packageType = this.packageInfo.detail.packageType
        getInfoApplicationSelect(data).then(res => {
          if (res.code === 0) {
            // this.getSelect = true
            if (res.data.model) {
              this.unApplyOptionList = res.data.model
              if (value === 'MODULE_7' && this.packageInfo.oriented === 'SCHOOL') {
                this.isShowSelect = true
              }
              if (value === 'MODULE_8' && this.packageInfo.oriented === 'CAREER') {
                this.isShowSelect = true
              }
            }
          }
        })
      }
    },
    // 点击Tab
    handleTab () {
      if (this.tabName === 'applyName') {
        this.isShowSelect = false
        this.$set(this.formData, 'courseId', '')
      }
      this.$set(this.formData, 'module', '')
      this.$set(this.formData, 'type', '')
      this.$set(this.formData, 'jointId', '')
      this.$set(this.formData, 'predictTime', '')
      this.$set(this.formData, 'title', '')
      this.$set(this.formData, 'menteeZone', '')
      this.formData.timeContent = [[], [], []]
      this.formData.courseId = ''
      this.showTips = false
    },
    // 获取sm导师
    getJointSM () {
      getJointSM().then(res => {
        this.mentorList = res.data.model
      })
    },
    // 获取em导师
    getJointCM () {
      getJointCM().then(res => {
        this.mentorList = res.data.model
      })
    },
    // 获取smem导师
    getJointSMCM () {
      getJointSMCM({}).then(res => {
        this.mentorList = [...res.data.cmList, ...res.data.smList]
      })
    },
    // 选择导师
    selMentorHandle (item) {
      this.selMentorDetail = item
      this.$set(this.formData, 'jointId', item.id)
      if (item.id) {
        this.getAppRemainTime(item)
      } else {
        this.remainTime = {}
      }
      this.predictTimeHandle('')
    },
    // 获取剩余时间
    getAppRemainTime (item) {
      getAppRemainTime({
        'jointId': item.id,
        'module': this.formData.module,
        'appointmentType': this.formData.type
      }).then(res => {
        this.remainTime = res.data.model
      })
    },
    // 预约时间
    predictTimeHandle (time) {
      this.$set(this.formData, 'predictTime', time)
      this.$set(this.formData, 'title', '')
      this.cancelZoneHandle()
    },
    // 主体失去焦点
    titleBlurHandle () {
      if (this.formData.title) {
        this.showTips = true
      }
    },
    // 清除失去
    cancelZoneHandle () {
      this.showTips = false
      this.$set(this.formData, 'menteeZone', '')
      this.changeMenteeZone()
    },
    changeMenteeZone () {
      this.clearTimeHandle(0)
      this.firstDateHandle()
    },
    // 首选 - 选择日期
    firstDateHandle () {
      this.clearTimeHandle(1)
      this.secondDateHandle(2)
      this.timeCompare(0)
    },
    // 首选 - 选择时间
    firstTimeHandle () {
      this.clearTimeHandle(1)
      this.secondDateHandle(2)
      this.timeCompare(0)
    },
    // 次选 - 选择日期
    secondDateHandle () {
      this.clearTimeHandle(2)
      this.threeDateHandle()
      this.timeCompare(1)
    },
    // 次选 - 选择时间
    secondTimeHandle () {
      this.clearTimeHandle(2)
      this.threeDateHandle()
      this.timeCompare(1)
    },
    // 次选 - 选择日期
    threeDateHandle () {
      this.$set(this.formData, 'description', '')
      this.timeCompare(2)
    },
    // 次选 - 时间
    threeTimeHandle () {
      this.timeCompare(2)
    },
    // 进续转换时间比较
    timeCompare (index) {
      let time = this.formData.timeContent[index]
      this.$set(this.compareTime, index, false)
      if (!time[0] || !(time[1] && time[1][1] && time[1][1][0])) {
        return false
      }
      let date = dayjs(time[0]).format('YYYY-MM-DD')
      let timeQuantum = {
        minTimeStr: `${date} ${time[1][0]}`,
        maxTimeStr: `${date} ${time[1][1]}`
      }
      getAppTimeConvert({
        menteeZone: this.formData.menteeZone,
        mentorZone: this.selMentorDetail.mentorInfo.mentorZone,
        timeQuantum
      }).then(res => {
        let { minTimeStr, maxTimeStr, minTime, maxTime } = res.data.model
        // 导师时区
        this.transferMentortime.splice(index, 1, {
          minTimeStr,
          maxTimeStr
        })
        // 转换到学生选择的时区
        this.transferMenteetime.splice(index, 1, {
          minTime,
          maxTime
        })
        // 时间比较
        let minHour = dayjs(minTimeStr).hour()
        let maxHour = dayjs(maxTimeStr).hour()
        if ((minHour > 0 && minHour < 6) || (maxHour > 0 && maxHour < 6)) {
          this.$set(this.compareTime, index, true)
        }
      })
    },
    clearTimeHandle (index) {
      this.$set(this.formData.timeContent, index, [])
    },
    // 讨论主体提示
    themeHandle () {
      this.$refs.theme.showHandle()
    },
    // 返回
    backHandle () {
      this.$router.push({
        path: '/mentor/record'
      })
    },
    // tips 颜色显示
    changeTipsColor () {
      let color = 'blue'
      let isCompareTime = this.compareTime.some(item => item)
      let isValiateTime = false
      let self = this
      this.transferMenteetime.forEach(time => {
        if (self.transferCurrentTime(time)) {
          isValiateTime = true
        }
      })
      if (isCompareTime || isValiateTime) {
        color = 'orange'
      }
      this.tipsColor = color
    },
    // 学生选择时区 把当前时间转换选择的时区
    transferCurrentTime (time) {
      return this.$options.filters.compareMenteeTime(time)
    },
    // 添加辅导时间时间段
    chanbgeAddTimeContent () {
      this.isAddTimeContent = !this.isAddTimeContent
      if (!this.isAddTimeContent) {
        this.secondTimeHandle()
        if (this.transferMentortime.length > 2) {
          // 导师时区
          this.transferMentortime.splice(2, 1)
        }
      }
    },
    // 置换时间
    handleReplaceDiy () {
      let modules = this.formData.module
      if (['MODULE_1', 'MODULE_2', 'MODULE_3'].includes(modules)) {
        this.$refs['replaceBook'].showHandle()
      }
      if (['MODULE_7', 'MODULE_8'].includes(modules)) {
        this.$refs['repalceDiy'].showHandle()
      }
    },
    // 置换成功
    handleReplaceSuc () {
      this.getAppRemainTime()
    }
  },
  filters: {
    filterZone (value) {
      if (!value) return ''
      return zoneMap.filter(item => item.value === value)[0]['title']
    },
    filerExpectTime (value) {
      return dayjs(value[0]).format('YYYY-MM-DD') + ' ' + value[1].join('-')
    },
    compareMenteeTime (time) {
      let currentTime = (new Date()).getTime()
      let disMinTime = 9 * 60 * 60 * 1000
      let disMaxTime = 9 * 24 * 60 * 60 * 1000
      let title = ''
      if ((time.minTime - currentTime < disMinTime)) {
        title = '- 预约辅导时间距离现在不足9个小时，建议重新选择时间'
      }
      if (time.maxTime - currentTime > disMaxTime) {
        title = '- 预约辅导时间距离现在超过9天，建议重新选择时间'
      }
      return title
    },
    filterWeek (arr) {
      let conArr = []
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          conArr.push(`${week[item.week - 1]} ${item.time}`)
        })
      }
      return conArr.join('、')
    },
    filtersMentorTitle (value) {
      let title = ''
      switch (value) {
        case 'MODULE_1':
        case 'MODULE_2':
        case 'MODULE_3':
          title = '文书辅导，SM导师'
          break
        case 'MODULE_7':
          title = '个性化辅导，SM导师'
          break
        case 'MODULE_8':
          title = '个性化辅导，CM导师'
          break
      }
      return title
    }
  },
  watch: {
    formData: {
      handler (data) {
        let index = 0
        if (data.description) {
          index = 10
        } else if (data.timeContent[2][0] && data.timeContent[2][1]) {
          index = 9
        } else if (data.timeContent[1][0] && data.timeContent[1][1]) {
          index = 8
        } else if (data.timeContent[0][0] && data.timeContent[0][1]) {
          index = 7
        } else if (data.menteeZone) {
          index = 6
        } else if (data.title) {
          index = 5
        } else if (data.predictTime) {
          index = 4
        } else if (data.jointId) {
          index = 3
        } else if (data.module) {
          index = 2
        } else if (data.videoType) {
          index = 1
        } else {
          index = 0
        }
        this.percent = (index / 10) * 100
      },
      deep: true
    },
    transferMenteetime: {
      handler (data) {
        let isAll = data.every(item => item.minTime)
        if (isAll) {
          this.changeTipsColor()
        }
      },
      deep: true
    }
  }
}
</script>
<style lang='less' scoped>
.select-box{
  /deep/ .ivu-select-single .ivu-select-selection{
    height:46px;
    border-color:rgba(0,0,0,.25);
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,/deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
    height:48px;
    line-height:48px;
    padding-left:29px;
    border-radius: 5px;
  }
  /deep/ .ivu-select-item{
    padding-left:29px;
    padding-right:29px;
  }
  .slect-title{
    padding-bottom:10px;
  }
}
.select-tip-main{
  padding-top:24px;
  .course-mian{
    line-height: 24px;
    padding-bottom: 7px;
    display:flex;
    .course-title-left{
      width:100px;
    }
  }
}
</style>
